export default {} as {
  [key: string]: any | undefined
}
